<!-- Page Wrapper -->
<!-- <div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border"> -->
            <!--page body contant -->
            <!--header-->
            <!-- <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-medkit"></i> Approvals</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <button class="btn btn-primary btn-sm"  routerLink="/dashboard"><i class="fa fa-arrow-left"></i> Back</button>
                </div>
            </div> -->
            <!--end header-->

            <div class="row">
                <div class="col-12">
                    <div class="alert alert-warning alert-dismissible fade show" role="alert">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-10">
                                    <strong>Holy guacamole!</strong> You should check in on some of those fields below.You should check in on some of those fields below.You should check in on some of those fields below.You should check in on some of those fields below.You should check in on some of those fields below.You should check in on some of those fields below.
                                </div>
                                <div class="col-2">
                                    <button type="button" class="btn btn-sm btn-danger float-right m-l-5">Reject</button>
                                    <button type="button" class="btn btn-sm btn-success float-right " data-dismiss="alert" aria-label="Close">
                                    Approved
                                    </button>
                                </div>
                            </div>
                        </div>
                      </div>
                </div>
                <div class="col-12">
                    <div class="alert alert-warning alert-dismissible fade show" role="alert">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-10">
                                    <strong>Holy guacamole!</strong> You should check in on some of those fields below.You should check in on some of those fields below.You should check in on some of those fields below.You should check in on some of those fields below.You should check in on some of those fields below.You should check in on some of those fields below.
                                </div>
                                <div class="col-2">
                                    <button type="button" class="btn btn-sm btn-danger float-right m-l-5">Reject</button>
                                    <button type="button" class="btn btn-sm btn-success float-right " data-dismiss="alert" aria-label="Close">
                                    Approved
                                    </button>
                                </div>
                            </div>
                        </div>
                      </div>
                </div>
            </div>
            

      <!--end page body contant -->
        <!-- </div>
    </div>
</div> -->
<!-- /Page Wrapper -->           

